import Button from "Components/Common/Button/Button";
import { YesNoValue } from "../types/precon.types";

interface YesNoRowProps {
  label: string;
  subLabel?: string;
  value: YesNoValue;
  onChange: (value: YesNoValue) => void;
}

const YesNoRow = ({ label, subLabel, value, onChange }: YesNoRowProps) => {
  return (
    <div className="ynRow">
      <div>
        <div className="ynLabel">{label}</div>
        {subLabel ? <div className="ynSub">{subLabel}</div> : null}
      </div>
      <div className="ynBtns">
        <Button
          className={`ynBtn ${value === "yes" ? "yesOn" : ""}`}
          type="button"
          onClick={() => onChange("yes")}
        >
          Yes
        </Button>
        <Button
          className={`ynBtn ${value === "no" ? "noOn" : ""}`}
          type="button"
          onClick={() => onChange("no")}
        >
          No
        </Button>
        <Button
          className={`ynBtn ${value === "na" ? "naOn" : ""}`}
          type="button"
          onClick={() => onChange("na")}
        >
          N/A
        </Button>
      </div>
    </div>
  );
};

export default YesNoRow;
